module.exports = __webpack_public_path__ + "static/media/03.2601e0a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/volumetric/baggage/03.png
// module id = 628
// module chunks = 0